import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css";

const Login: React.FC = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const response = await login(phone, password);
      
      if (response.success) {
        const role = response.user.role;

        switch(role) {
          case "megaadmin":
            navigate("/dashboard/mega");
            break;
          case "super_admin":
            navigate("/dashboard/super");
            break;
          case "admin":
            navigate("/dashboard/admin");
            break;
          case "receptionniste":
            navigate("/dashboard/receptionniste");
            break;
          case "protocole":
            navigate("/dashboard/protocole");
            break;
          case "organisateur":
            navigate("/dashboard/organizer");
            break;
          default:
            navigate("/dashboard");
        }
      } else {
        setError(response.message || "Erreur de connexion");
      }
    } catch (err: any) {
      console.error("Login error:", err);
      setError(err.message || "Numéro ou mot de passe invalide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "420px" }}>
        <h3 className="text-center mb-4">Connexion</h3>
        
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">Numéro de téléphone</label>
            <input
              type="text"
              id="phone"
              className="form-control"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Mot de passe</label>
            <input
              type="password"
              id="password"
              className="form-control"
              placeholder="Entrez votre mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Connexion en cours..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;